import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions, { clearLoginErrors } from './actions'
import initialState from './initialState'

const loginStart = (state): any => ({
  ...state,
  loginStatus: LoadingStates.Loading,
})

const loginSuccess = (state): any => ({
  ...state,
  loginStatus: LoadingStates.LoadedSuccess,
  loginErrors: [],
})

const loginErrors = (state, errorMessage): any => {
  const normalizedErrors = [
    {
      target: 'password',
      message: errorMessage,
    },
  ]

  return {
    ...state,
    loginStatus: LoadingStates.LoadedFail,
    loginErrors: normalizedErrors,
  }
}
const clearLoginErrorsHandler = (state): any => {
  return {
    ...state,
    loginStatus: LoadingStates.NotLoaded,
    loginErrors: [],
  }
}

const proceedToCheckoutStart = (state): any => ({
  ...state,
  proceedToCheckoutStatus: LoadingStates.Loading,
})

const proceedToCheckoutSuccess = (state): any => ({
  ...state,
  proceedToCheckoutStatus: LoadingStates.LoadedSuccess,
})

const proceedToCheckoutFail = (state): any => ({
  ...state,
  proceedToCheckoutStatus: LoadingStates.LoadedFail,
})

const proceedToCheckoutReset = (state): any => ({
  ...state,
  proceedToCheckoutStatus: initialState.proceedToCheckoutStatus,
})

const fetchLoyaltyBenefitsListStart = (state): any => ({
  ...state,
  loyaltyBenefitsStatus: LoadingStates.Loading,
})

const fetchLoyaltyBenefitsListSuccess = (state, data): any => ({
  ...state,
  loyaltyBenefitsStatus: LoadingStates.LoadedSuccess,
  loyaltyBenefits: data['benefits-list'],
})

const fetchLoyaltyBenefitsListFail = (state): any => ({
  ...state,
  loyaltyBenefitsStatus: LoadingStates.LoadedFail,
})

export default createReducer((on) => {
  on(actions.loginStart, loginStart)
  on(actions.loginSuccess, loginSuccess)
  on(actions.loginErrors, loginErrors)
  on(clearLoginErrors, clearLoginErrorsHandler)
  on(actions.proceedToCheckoutStart, proceedToCheckoutStart)
  on(actions.proceedToCheckoutSuccess, proceedToCheckoutSuccess)
  on(actions.proceedToCheckoutFail, proceedToCheckoutFail)
  on(actions.proceedToCheckoutReset, proceedToCheckoutReset)
  on(actions.fetchLoyaltyBenefitsListStart, fetchLoyaltyBenefitsListStart)
  on(actions.fetchLoyaltyBenefitsListSuccess, fetchLoyaltyBenefitsListSuccess)
  on(actions.fetchLoyaltyBenefitsListFail, fetchLoyaltyBenefitsListFail)
}, initialState)
